/**
 * 用户相关
 * */

import $axios from '@/api/axios'

// 登录
export function login(data) {
    return $axios({
        url: '/login/loginNoCaptcha',
        method: 'post',
        data
    })
}
